enum WorkspaceProjectUtilityUnitOfMeasurementSymbol {
  '%' = '%',
  'US$' = 'US$',
  'Million US$' = 'Million US$',
  'kg' = 'kg',
  'ha' = 'ha',
  'tCO2e' = 'tCO2e',
  'tCO2e/ha' = 'tCO2e/ha',
  'months' = 'months',
  'no symbol' = 'no symbol',
}

export default WorkspaceProjectUtilityUnitOfMeasurementSymbol
